module.exports = __webpack_public_path__ + "img/hoppin-john.719b5cee.jpg";